import { displayUpdateInfo } from "@modules/bookmarks/advert-page/bookmarks.ts"
import { updateMerkzettelStateInMenu } from "@modules/bookmarks/bookmarks-menu-item.ts"
import { queryElement } from "@modules/bookmarks/html-elements.ts"
import { InfoPanel } from "@modules/info-panel/InfoPanel.ts"
import { Cookie } from "@modules/util/Cookie.ts"
import QRCode from "easyqrcodejs"

const shareModalElement = (): HTMLDivElement | null =>
    document.getElementById("merkzettel-modal-share-all") as HTMLDivElement | null

const mailModalElement = (): HTMLDivElement | null => document.getElementById("mail-modal") as HTMLDivElement | null

export async function addListenerToShareButton() {
    const shareModal = shareModalElement()

    if (!shareModal) {
        return
    }

    const modalLinkButton = queryElement(".merkzettel-link", shareModal) as HTMLInputElement
    const modalValidToDate = queryElement(".valid-to-date") as HTMLSpanElement
    const modalValidToTime = queryElement(".valid-to-time") as HTMLSpanElement
    const modalShareQrCode = queryElement("#shared-merkzettel-code", shareModal) as HTMLImageElement

    const validToDate = document.getElementById("valid-to-date") as HTMLElement
    const validToTime = document.getElementById("valid-to-time") as HTMLElement

    modalLinkButton.value = window.location.href
    modalValidToDate.innerHTML = validToDate.innerHTML
    modalValidToTime.innerHTML = validToTime.innerHTML

    new QRCode(modalShareQrCode, {
        link: window.location.href,
        height: 110,
        width: 110,
    }).makeCode(window.location.href)
}

export async function addListenersToMailButton() {
    const mailModal = mailModalElement()

    if (!mailModal) {
        return
    }

    const modalAdvertLogoImage = queryElement(".versand-thumb", mailModal) as HTMLImageElement
    const modalAdvertName = queryElement(".versand-name", mailModal) as HTMLDivElement
    const modalAdvertCity = queryElement(".versand-city", mailModal) as HTMLDivElement
    const modalBody = queryElement(".modal-body", mailModal) as HTMLDivElement

    const mailButtons = document.querySelectorAll<HTMLButtonElement>(".entry-send-request")

    for (let i = 0; i < mailButtons.length; i++) {
        const mailButton = mailButtons[i]
        mailButton.addEventListener("click", async (e) => {
            const article = (e.currentTarget as HTMLElement).closest("article.entry-card")
            if (!article) return

            const fkkLogo = article.querySelector(
                "section.entry-card--contents > div.entry-card--photo > a:nth-child(1) > img",
            )
            const advertName = article.querySelector(
                "section.entry-card--contents > div.entry-card--text-contents > h3 > a > strong",
            )
            const advertCity = article.querySelector(
                "section.entry-card--contents > aside > div > div:nth-child(1) > h2 > strong",
            )

            if (SiteInfo.isMobileVersion) {
                let infoContainer = document.getElementById("mail-modal-advert-info")

                if (!infoContainer) {
                    infoContainer = document.createElement("div")
                    infoContainer.setAttribute("id", "mail-modal-advert-info")
                    infoContainer.classList.add("auftrag-info", "clearfix")

                    const img = document.createElement("img")
                    img.classList.add("img-responsive", "pull-left", "share-advert-thumbnail")
                    img.setAttribute("src", fkkLogo ? fkkLogo.getAttribute("src") || "" : "")

                    const name = document.createElement("div")
                    name.classList.add("share-advert-name")
                    name.innerHTML = advertName ? advertName.innerHTML : ""

                    const city = document.createElement("div")
                    city.classList.add("share-advert-place")
                    city.innerHTML = advertCity ? "in " + advertCity.innerHTML : ""

                    infoContainer.appendChild(img)
                    infoContainer.appendChild(name)
                    infoContainer.appendChild(city)

                    modalBody.prepend(infoContainer)
                } else {
                    const img = infoContainer.querySelector("img.share-advert-thumbnail") as HTMLImageElement
                    const name = infoContainer.querySelector("div.share-advert-name") as HTMLDivElement
                    const city = infoContainer.querySelector("div.share-advert-place") as HTMLDivElement

                    img.setAttribute("src", fkkLogo ? fkkLogo.getAttribute("src") || "" : "")
                    name.innerHTML = advertName ? advertName.innerHTML : ""
                    city.innerHTML = advertCity ? "in " + advertCity.innerHTML : ""
                }
            } else {
                modalAdvertLogoImage.setAttribute("src", fkkLogo ? fkkLogo.getAttribute("src") || "" : "")
                modalAdvertName.innerHTML = advertName ? advertName.innerHTML : ""
                modalAdvertCity.innerHTML = advertCity ? advertCity.innerHTML : ""
            }

            $(mailModal).modal("show")
        })
    }
}

export async function addListenerToIntegrateAllButton() {
    document.getElementById("merkzettel-integrate-all")?.addEventListener("click", () => {
        takeOverAllEntries()
    })
}
export async function addListenersToStarIcon() {
    const buttons = document.querySelectorAll<HTMLButtonElement>(".merkzettel-button")

    for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i]
        const isOffline = button?.getAttribute("data-is-offline") === "true"
        const addSpan = button.querySelector<HTMLElement>(".memo-add")
        const removeSpan = button.querySelector<HTMLElement>(".memo-remove")
        const advertId = button.getAttribute("data-auftrags-id")

        if (!addSpan || !removeSpan || !advertId) return

        addSpan.addEventListener("click", async (e) => {
            let article = null
            if (isOffline) {
                article = (e.currentTarget as HTMLElement).closest(".item.offline")
            } else {
                article = (e.currentTarget as HTMLElement).closest("article.entry-card")
            }
            if (!article) return

            const id = article.getAttribute("data-canonical-id")
            if (!id) return

            const requestData = {
                canonicalId: id,
                advertId: Number.parseInt(article.getAttribute("data-advert-id") || "0"),
            }
            const success = await toggleEntries([requestData], "add")

            if (success) {
                addSpan.style.display = "none"
                removeSpan.style.display = "block"
                displayUpdateInfo("Die Anzeige wurde erfolgreich zum Merkzettel hinzugefügt.")
            }
        })

        removeSpan.addEventListener("click", async (e) => {
            let article = null
            if (isOffline) {
                article = (e.currentTarget as HTMLElement).closest(".item.offline")
            } else {
                article = (e.currentTarget as HTMLElement).closest("article.entry-card")
            }
            if (!article) return

            const advertId = article.getAttribute("data-advert-id")
            const canonicalId = article.getAttribute("data-canonical-id")
            if (!canonicalId) return

            const requestData = { advertId: Number(advertId), canonicalId: canonicalId }
            const success = await toggleEntries([requestData], "delete")

            if (success) {
                removeSpan.style.display = "none"
                addSpan.style.display = "block"
                displayUpdateInfo("Die Anzeige wurde erfolgreich aus dem Merkzettel entfernt.")
            }
        })
    }
}

export function setNavigationCookie() {
    new Cookie("navigationCookie", {
        path: "/",
        expires: Cookie.getExpireDate(3600 * 24),
        domain: SiteInfo.cookieDomain,
        value: {
            referrerTitle: "favourite-bookmarks",
            backlinkUrl: window.location.href,
        },
    })
}

async function takeOverAllEntries() {
    const entries = document.querySelectorAll(".entry-card, .item.offline")
    const ids = []

    for (let i = 0; i < entries.length; i++) {
        const entry = entries[i]
        const canonicalId = entry.getAttribute("data-canonical-id")

        if (canonicalId) {
            const requestData = {
                canonicalId: canonicalId,
                advertId: Number.parseInt(entry.getAttribute("data-advert-id") || "0"),
            }

            ids.push(requestData)
        }
    }

    const success = await toggleEntries(ids, "add")
    if (success) {
        const addSpans = document.querySelectorAll<HTMLElement>(".memo-add")
        const removeSpans = document.querySelectorAll<HTMLElement>(".memo-remove")

        for (let i = 0; i < addSpans.length; i++) {
            addSpans[i].style.display = "none"
        }

        for (let i = 0; i < removeSpans.length; i++) {
            removeSpans[i].style.display = "block"
        }
        displayUpdateInfo("Alle Anzeigen wurden erfolgreich zum Merkzettel hinzugefügt.")
    }
}

async function toggleEntries(
    adverts: { canonicalId: string; advertId: number }[],
    action: "add" | "delete",
): Promise<boolean> {
    let api: string
    if (userData.userId === 0) {
        api = `/api/bookmarks/${action}`
    } else {
        api = `/api/bookmarks/${userData.userId}/${action}`
    }

    let data: { ids: { canonicalId: string }[] } | { canonicalId: string; advertId: number; confirm: boolean }

    if (action === "add") {
        data = {
            ids: adverts.map((advert) => ({
                canonicalId: advert.canonicalId,
                advertId: advert.advertId,
            })),
        }
    } else {
        data = {
            canonicalId: adverts[0].canonicalId,
            advertId: adverts[0].advertId,
            confirm: true,
        }
    }

    try {
        const response = await fetch(api, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(data),
        })

        if (!response.ok) {
            response.json().then((errorData) => {
                InfoPanel.displayMessage(
                    errorData.message || "Fehler beim Aktualisieren des Merkzettels.",
                    InfoPanel.Type.Error,
                    3000,
                )
            })
            return false
        }

        updateMerkzettelStateInMenu(true)

        return response.ok
    } catch (error) {
        return false
    }
}
